import React from "react";
import { CompletionLoader, DeveloperLoader, ImageLoader, LocationLoader, PropertyLoader, TitleLoader } from "./LoaderCommon";

export default function PropertiesLoader() {
    return (
        <div className="slider-card project-slider-card">
            <div className="slide-card-img">
                <ImageLoader />
            </div>
            <div className="heading_title">
                <TitleLoader />
            </div>
            <div className="geo-location">
                <LocationLoader />
            </div>
            <div className="property-price">
                <p>
                    <DeveloperLoader />
                </p>
                <p>
                    <DeveloperLoader />
                </p>
            </div>
            <div className="property-details border border-0">
                <div className="detail-item border-0">
                    <PropertyLoader />
                </div>
                <div className="detail-item border-0">
                    <PropertyLoader />
                </div>
                <div className="detail-item border-0">
                    <PropertyLoader />
                </div>
            </div>
            <div className="flex items-center info_wrapper">
                <div className="item-summary">
                    <CompletionLoader />
                </div>
                <div className="item-summary">
                    <CompletionLoader />
                </div>
            </div>
        </div>
    );
}
